module.exports = __webpack_public_path__ + "media/images/DailyHerald-88d245cec67bbb703d1af2a2a8ded210.png";